import React, { useState } from 'react'
import {
  Typography,
  Divider,
  LinearProgress,
  IconButton,
  Checkbox,
} from '@material-ui/core'
import { ExecutionDetails, ExecutionStatus, isRunningOrQueued } from '../../../shared/src/data/executionDetails'
import { useStyles } from './Styles'
import { Delete } from '@material-ui/icons'
import { useExecutions } from '../steps/queries/executions'
import ConfirmationDialog from './ConfirmDialog'
import PlayExecution from './PlayExecution'

interface ExecutionItemProps {
  execution: ExecutionDetails
  checked: boolean
  addExecutionToSelection: (execution: string) => void
  removeExecutionFromSelection: (execution: string) => void
  remoteRunning: boolean
}

export default function ExecutionItem({
  execution,
  checked,
  addExecutionToSelection,
  removeExecutionFromSelection,
  remoteRunning,
}: ExecutionItemProps): JSX.Element {
  const styles = useStyles()
  const [openDialog, setOpenDialog] = useState(false)
  const { removeExecution } = useExecutions()

  const [executionToDelete, setExecutionToDelete] =
    useState<ExecutionDetails | null>(null)

  const handleDeleteClick = (execution: ExecutionDetails) => {
    setExecutionToDelete(execution)
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setExecutionToDelete(null)
  }

  const handleConfirmDelete = () => {
    if (executionToDelete) {
        removeExecution(executionToDelete.id)
    }
    handleCloseDialog()
  }

  const toggleExecutionSelection = () => {
    if (checked) {
        removeExecutionFromSelection(execution.id)
    } else {
        addExecutionToSelection(execution.id)
    }
};
    const isRunningOrQueues = isRunningOrQueued(execution.status)
  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
        <Checkbox disabled={isRunningOrQueues} checked={checked} onChange={toggleExecutionSelection}/>
        <PlayExecution execution={execution} remoteRunning={remoteRunning}/>
        <div style={{ flex: 1 }}>
          <Typography className={styles.executionItemTitle}>
            {execution.projectName || 'No project name'}
          </Typography>
          {execution.phase ? (
            <Typography className={styles.executionItemSubtitle}>
              Phase: {execution.phase}
            </Typography>
          ) : null}
          <Typography className={styles.executionItemSubtitle}>
            Scan id: {execution.scanId}
          </Typography>
        </div>
        { execution.status === ExecutionStatus.Running && <LinearProgress style={{ width: '250px' }} />}
        <IconButton
           disabled={isRunningOrQueues || remoteRunning} 
          onClick={() => handleDeleteClick(execution)}
          size='small'
          className={styles.deleteButton}
        >
          <Delete fontSize='small' />
        </IconButton>
      </div>
      <Divider style={{ margin: '8px 0' }} />
      <ConfirmationDialog
        open={openDialog}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmDelete}
        message={`Are you sure you want to delete the execution: ${executionToDelete?.projectName}?`}
      />
    </div>
  )
}
